module.exports = __webpack_public_path__ + "../resources/img/ic_re_message_default.b555bf49.svg";